import { Navigate, Route, Routes } from 'react-router-dom'
import GameHostPage from '@pages/GameHostPage'
import ExportsPage from '@pages/ExportsPage'
import LoginPage from '@pages/LoginPage'
import MainHomePage from '@pages/MainHomePage'
import GameHomeRoute from '@routing/GameHomeRoute'
import GamePageRoute from '@routing/GamePageRoute'
import {
  AbPage,
  AffiseRecalcPage,
  AdBlacklistPage,
  AdExpensesPage,
  AdMappingPage,
  AdNetworkExpensesPage,
  AdRecalcQueuePage,
  AdSpotsPage,
  LtvPage,
  MxBlacklistPage,
  MxHourlyPage,
  MxSessionsPage,
  PaymentsGameDaysPage,
  PaymentsPage,
  PaymentsPerHourPage,
  PaymentsRawPage,
  PaymentsTopUsersPage,
  PostbacksPage,
  ReportsPage,
  RetentionExportPage,
  RetentionPage,
  RevSharePage,
  SummaryPage,
  UsersPage,
} from '@routing/gamePageComponents'
import { getCurrentHostRoute } from '@routing/subdomains'

function App() {
  const hostRoute = getCurrentHostRoute()

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {hostRoute.kind === 'main' ? (
        <>
          <Route path="/" element={<MainHomePage />} />
          <Route path="/exports/*" element={<ExportsPage />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </>
      ) : (
        <Route
          path="/"
          element={<GameHostPage subdomain={hostRoute.subdomain} />}
        >
          <Route index element={<GameHomeRoute />} />
          <Route path="ab/*" element={<GamePageRoute Page={AbPage} />} />
          <Route
            path="ad/blacklist/*"
            element={<GamePageRoute Page={AdBlacklistPage} />}
          />
          <Route
            path="ad/affise-recalc/*"
            element={<GamePageRoute Page={AffiseRecalcPage} />}
          />
          <Route
            path="ad/spots/*"
            element={<GamePageRoute Page={AdSpotsPage} />}
          />
          <Route
            path="ad/mapping/:network/*"
            element={<GamePageRoute Page={AdMappingPage} />}
          />
          <Route
            path="ad/recalc/queue/*"
            element={<GamePageRoute Page={AdRecalcQueuePage} />}
          />
          <Route path="ad/tabular/*" element={<GamePageRoute Page={AdExpensesPage} />} />
          <Route
            path="ad/expenses/*"
            element={<GamePageRoute Page={AdNetworkExpensesPage} />}
          />
          <Route path="ad/expenses/:network/*" element={<GamePageRoute Page={AdExpensesPage} />} />
          <Route
            path="ad/revshare/*"
            element={<GamePageRoute Page={RevSharePage} />}
          />
          <Route path="ad/*" element={<GamePageRoute Page={AdExpensesPage} />} />
          <Route path="ltv/*" element={<GamePageRoute Page={LtvPage} />} />
          <Route
            path="payments/game-days/*"
            element={<GamePageRoute Page={PaymentsGameDaysPage} />}
          />
          <Route path="payments/raw/*" element={<GamePageRoute Page={PaymentsRawPage} />} />
          <Route
            path="payments/top-users/*"
            element={<GamePageRoute Page={PaymentsTopUsersPage} />}
          />
          <Route
            path="payments/per-hour/*"
            element={<GamePageRoute Page={PaymentsPerHourPage} />}
          />
          <Route path="payments/*" element={<GamePageRoute Page={PaymentsPage} />} />
          <Route path="postbacks/*" element={<GamePageRoute Page={PostbacksPage} />} />
          <Route path="reports/*" element={<GamePageRoute Page={ReportsPage} />} />
          <Route
            path="retention/export/*"
            element={<GamePageRoute Page={RetentionExportPage} />}
          />
          <Route
            path="retension/export/*"
            element={<GamePageRoute Page={RetentionExportPage} />}
          />
          <Route path="retention/*" element={<GamePageRoute Page={RetentionPage} />} />
          <Route path="mx/hourly/*" element={<GamePageRoute Page={MxHourlyPage} />} />
          <Route path="mx/sessions/*" element={<GamePageRoute Page={MxSessionsPage} />} />
          <Route
            path="mx/settings/blacklist/*"
            element={<GamePageRoute Page={MxBlacklistPage} />}
          />
          <Route path="summary/*" element={<GamePageRoute Page={SummaryPage} />} />
          <Route path="users/*" element={<GamePageRoute Page={UsersPage} />} />
          <Route path="*" element={<GameHomeRoute />} />
        </Route>
      )}
    </Routes>
  )
}

export default App
